export default "__VITE_PUBLIC_ASSET__0a3d3ee6__"